import styled from 'styled-components';

import { TOGGLE_ICON_SIZE } from '@front/common/src/components/accordion/constants';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Skeleton from '@front/web-ui/src/components/skeleton/skeleton';

const t = translate('basket.cleaning.services');

const StyledSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-right: ${15 + TOGGLE_ICON_SIZE}px;
`;

type AccordionSubtitlePriceProps = {
  formattedTotalPriceAfterTax: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoadingPrices: boolean;
  shouldShowTaxCreditLines: boolean;
};

const AccordionSubtitlePrice = ({
  formattedTotalPriceAfterTax,
  isITCSelectedOrSuccessfullyPaired,
  isLoadingPrices,
  shouldShowTaxCreditLines,
}: AccordionSubtitlePriceProps) => {
  if (!shouldShowTaxCreditLines) return undefined;

  if (isLoadingPrices)
    return (
      <StyledSubtitle>
        <Skeleton linesWidth={isITCSelectedOrSuccessfullyPaired ? ['70px'] : ['70px', '110px']} />
      </StyledSubtitle>
    );

  return (
    <StyledSubtitle>
      {isITCSelectedOrSuccessfullyPaired ? (
        <Text.MDBold>{formattedTotalPriceAfterTax}</Text.MDBold>
      ) : (
        <>
          <Text>{`${t('base.or')} ${formattedTotalPriceAfterTax}`}</Text>
          <Text.SM>{`\xa0${t('.accordion_subtitle_after_tax')}`}</Text.SM>
        </>
      )}
    </StyledSubtitle>
  );
};

export default AccordionSubtitlePrice;
